import React, {Fragment, useState} from 'react';
import ReactPlayer from 'react-player';
import { Button } from 'reactstrap';
import cx from "classnames";

import { showToast, customLoader } from '../../Common/Appcommon';
import requestApi from '../../services/requestApi.service';

const PlanContent = (props) => {

    const [showLoader, setShowLoader] = useState(false);

    let currentMenu = props.currentMenu;
    let menuname = currentMenu.name ? currentMenu.name : "";
    let url = "https://www.youtube.com/watch?v=q10qGSHaMJ4";
    if(menuname === "call_tracking"){
        url = "https://www.youtube.com/watch?v=q10qGSHaMJ4";
    }else if(menuname === "call_recording"){
        url = "https://www.youtube.com/watch?v=8AwIJZj07s8";
    }else if(menuname === "whatsapp"){
        url = "https://www.youtube.com/watch?v=QSNa8U1yGrM";
    }else if(menuname === "workflows"){
        url = "https://www.youtube.com/watch?v=Rwe5Aw3KPHY";
    }else if(menuname === "ffa"){
        url = "https://www.youtube.com/watch?v=DH89XAIRMmM";
    }else if(menuname === "customforms"){
        url = "https://www.youtube.com/watch?v=5DjjHTxbTu8";
    }else if(menuname === "api"){
        url = "https://www.youtube.com/watch?v=RDoVlHFsnwI";
    }

    const handleClick = async (currentMenu) => {
        let menulabel = currentMenu.label ? currentMenu.label : "";
        let menuname = currentMenu.name ? currentMenu.name : "";
        let params = {
            "ENTITY":"WHATSAPPPROCESS",
            "OPERATION":"explore_plan", 
            "method":"SEND_EMAIL",
            "menulabel" : menulabel,
            "menuname" : menuname,
        };
        setShowLoader(true);
        let response = await requestApi.processServerRequest(params);
        setShowLoader(false);
        if(response.issuccess && response.data === "Success"){
            showToast("Your request has been sent to support. You will be notified shortly.");
        }else{
            showToast("Something went wrong...", "", "error");
        }
    }

    const getPlanContent = () => {
        return(
            <Fragment>
                <div>
                    <div className='call-rec-plan'>
                        <div>
                            <ReactPlayer
                                url={url}
                                controls={true}
                                width='720px'
                                height='400px'
                                className="video-radius"
                            />
                        </div>
                        <div>
                            <div className='plan-notify-btn'>
                                <Button 
                                    className={cx("m-1 me-2 btn-icon le-button lePrimaryBtn")}
                                    onClick={e => handleClick(currentMenu)}
                                >
                                    Notify to Support
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

    return (
        <>
            {
                customLoader({
                    showLoader: showLoader,
                    customClass: "custom-class",
                    mainContent: getPlanContent(),
                })
            }
        </>
    )
}

export default PlanContent;
